import { render, staticRenderFns } from "./AccountsCardModal.vue?vue&type=template&id=84f97b52&scoped=true&"
import script from "./AccountsCardModal.vue?vue&type=script&lang=js&"
export * from "./AccountsCardModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountsCardModal.vue?vue&type=style&index=0&id=84f97b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f97b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84f97b52')) {
      api.createRecord('84f97b52', component.options)
    } else {
      api.reload('84f97b52', component.options)
    }
    module.hot.accept("./AccountsCardModal.vue?vue&type=template&id=84f97b52&scoped=true&", function () {
      api.rerender('84f97b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/AccountsCardModal.vue"
export default component.exports